import React from 'react';

const Loader: React.FC = () => {
    return (
        <div className="_text-align-center">
            <div className="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    );
};

export default Loader;
